export default __webpack_public_path__ + "static/media/AboutUs-Animated-banner-1.b6c10258.gif";